export enum SelfEvalStatus {
    Open = 'open',
    Approved = 'approved',
    Rejected = 'rejected'
};

export type SelfEvalResponse = {
    id?: string;
    classCode?: string;
    skill: string;
    eventId: string;
    response: string;
    selfEvalProblemId: string;
    status: SelfEvalStatus;
    timestamp: number;
};

export enum BugReportStatus {
    Open = 'open',
    ClosedWontFix = 'closed-wont-fix',
    ClosedFixed = 'closed-fixed'
}

export type BugReport = {
    id? : string;
    content: any;
    status: BugReportStatus;
    timestamp: number;
}